import { Type } from '@angular/core';

import { BlockView } from './block-view';
import { JuliaRecordBlockComponent } from './julia-record-block/julia-record-block.component';
import { JuliaTableBlockComponent } from './julia-table-block/julia-table-block.component';

/** The component that shows each kind of block. A message holding a kind missing here keeps its markdown. */
export const BLOCK_VIEWS: { [kind: string]: Type<BlockView> } = {
  table: JuliaTableBlockComponent,
  record: JuliaRecordBlockComponent,
};
